
import { UpdateProfileApiParameter, updateShowPriceToggleSetting } from "@dana/Services/DanaMyProfileService";
import { ShowPriceToggleActions } from "@dana/Store/Data/ShowPrice/Reducers/ShowPriceToggleReducer";
import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { DispatchProp } from "react-redux";


type HandlerType = ApiHandler<UpdateProfileApiParameter,
    {
        successful: boolean;
        errorMessage: any;
    },
    DispatchProp<ShowPriceToggleActions>
>;

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "ShowPrice/Toggle",
        isLoading: true,
    } as any);
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        ...props.parameter
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.dispatch({
        type: "ShowPrice/Toggle",
        canSeePrice: props.parameter.canSeePrice,
    } as any);
    await updateShowPriceToggleSetting(props.apiParameter);  
};
export const LoadToggelPriceResponse: HandlerType = props => {

    props.dispatch(loadSession({ isSessionUpdate: true }));
};

export const chain = [DispatchSetParameters, PopulateApiParameter, RequestDataFromApi, LoadToggelPriceResponse];

const toggleShowPriceSetting = createHandlerChainRunner(chain, "ToggleShowPriceSetting");
export default toggleShowPriceSetting;